import script from "./MEntradaNumerica.vue?vue&type=script&lang=ts&setup=true"
export * from "./MEntradaNumerica.vue?vue&type=script&lang=ts&setup=true"

import "./MEntradaNumerica.vue?vue&type=style&index=0&id=5f720230&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f720230"]])

export default __exports__